import { ILoginUser } from "../shared/interfaces/user/IUser";
import { formDataHeaders, requests } from "../utils/api/api.service";
import { AUTH_URL, BASE_URL } from "../utils/api/endpoints";
import { IChangePasswordProps } from "../app/profile/components/tabs/ChangePassword";
import { IConfirmPassword } from "../app/dashboard/components/ForgotPasswordModal";

export const AuthService = {
  login: (payload: ILoginUser) => requests.post(`${AUTH_URL}/signin`, payload),
  enums: () => requests.get(BASE_URL + "/enums"),
  me: () => requests.get(`${AUTH_URL}/me`),
  registerStepOne: (payload: FormData) =>
    requests.post(
      `${AUTH_URL}/customer/register/step-one`,
      payload,
      formDataHeaders,
    ),
  registerStepTwo: (payload: FormData, token: string) =>
    requests.post(
      `${AUTH_URL}/customer/register/step-two?token=${token}`,
      payload,
      formDataHeaders,
    ),
  update: (payload: FormData) =>
    requests.put(`${AUTH_URL}/me`, payload, formDataHeaders),
  changePassword: (payload: IChangePasswordProps) =>
    requests.put(`${AUTH_URL}/change-password`, payload),
  forgotPassword: (email: string) =>
    requests.post(`${AUTH_URL}/forgot-password-request`, { email }),
  forgotPasswordReset: (email: string, code: string) =>
    requests.post(`${AUTH_URL}/forgot-password-change`, {
      email,
      code,
    }),
  resetPassword: (payload: IConfirmPassword) =>
    requests.post(`${AUTH_URL}/forgot-password-change/final`, payload),
  impersonate: (id: number) =>
    requests.post(`${AUTH_URL}/impersonate/${id}`, {}),
  exitImpersonation: () => requests.post(`${AUTH_URL}/impersonate/exit`, {}),
};
